import { Backdrop } from "@mui/material";
import { Container } from "@mui/system";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { AxiosResponseHeaders } from "axios";
import Header from "components/header/Header";
import ValidationErrors from "components/modals/ValidationErrors";
import { selectCustomer } from "features/customer/customerSlice";
import { fetchValidateResponse } from "features/shoppingCart/fetchValidate";
import { checkShoppingCart, clearShoppingCart, purchaseShoppingCart, selectShoppingCartArticles, updatePrices } from "features/shoppingCart/shoppingCartSlice";
import { selectUserData, selectUserIsLoggedId } from "features/user/userSlice";
import React, { useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";


export default function CheckOrder() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [open, setOpen] = React.useState(false);
  const [navigateFurther, setNavigateFurther] = React.useState(false);
  const [informationText, setInformationText] = React.useState<string[]>([]);
  const { fromShoppingCart } = state
  const shoppingCartArticles = useAppSelector(selectShoppingCartArticles);
  const customerData = useAppSelector(selectCustomer);
  const userData = useAppSelector(selectUserData)
  let { city, street, street_number, zip_code, country_id } = customerData;
  let { first_name, last_name } = userData
  const isLoggedIn = useAppSelector(selectUserIsLoggedId)

  // useEffect(() => {
  //   dispatch(customerSettings())
  // }, [])

  useEffect(() => {
    if (!first_name || !last_name || !city || !street || !street_number || !zip_code || !country_id) {
      navigate("/kunde/mein_profil", { replace: true })
      setNavigateFurther(false);
    } else {
      setNavigateFurther(true)
    }
  }, [customerData, first_name, last_name, city, street, street_number, zip_code, country_id, navigate])


  useEffect(() => {
    if (!isLoggedIn) {
      // dispatch(clearShoppingCart());
      navigate("/login", { replace: true });
      setNavigateFurther(false);
    }
    // ... rest of your logic
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (navigateFurther) {
      //test order for invalid lot id
      dispatch(checkShoppingCart(shoppingCartArticles)).then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          const payload = response.payload as { headers: AxiosResponseHeaders; data: fetchValidateResponse; status: number };
          // Check if there are any errors in the response
          if (payload.data.data?.errors && payload.data.data?.errors.length > 0) {
            setOpen(true);
            setInformationText(payload.data.data.errors.map((error) => error.error));
            return false;
          } else if (payload.status >= 400) {
            setOpen(true);
            setInformationText([`Beim Prüfen der Bestellung ist ein Fehler aufgetreten (Code: ${payload.status}). Bitte versuchen Sie es später erneut.`]);
            return false;
          }
          return true
        }
        return false
      }).then((success) => {
        if (success) {
          if (!fromShoppingCart && isLoggedIn) {
            dispatch(purchaseShoppingCart(shoppingCartArticles)).then((response) => {
              const payload = response.payload as { headers: AxiosResponseHeaders; data: any; status: number };
              if (payload.status >= 400) {
                setOpen(true);
                setInformationText([`Beim Abschicken der Bestellung ist ein Fehler aufgetreten (Code: ${payload.status}). Bitte versuchen Sie es später erneut.`]);
                return;
              }

              navigate("/bestellung_erfolgreich", { replace: true });
              dispatch(clearShoppingCart());
            }).catch((err) => {
              // console.log('Errr....', err)
              console.error('Fehler beim Abrufen der Daten:', err);
            })
          } else {
            navigate("/bestelluebersicht", { replace: true });
          }
        }
      }).catch((err: any) => {
        setOpen(true);
        setInformationText([`Beim Prüfen der Bestellung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.`]);
        console.error('Fehler beim Abrufen der Daten:', err);
        // console.log(err)
      });
    }
  }, [navigateFurther, isLoggedIn, dispatch, fromShoppingCart, navigate, shoppingCartArticles])

  const handleClose = useCallback((event: any) => {
    event?.stopPropagation();
    setOpen(false);
    dispatch(updatePrices());
    navigate("/einkaufswagen")
  }, [dispatch, navigate]);

  return (
    <Container>
      <Header header="Ihre Bestellung wird geprüft" />
      <Backdrop sx={{ backgroundColor: "#grey", zIndex: 1200 }} open={open} onClick={handleClose}>
        <ValidationErrors 
          checked={open}
          handleClose={handleClose}
          text={informationText}
        />
      </Backdrop>
    </Container>
  )
}